var map = {
	"./clear.svg": "dGLe",
	"./cloudy-with-showers.svg": "UTAl",
	"./cloudy.svg": "ris8",
	"./cool.svg": "oORW",
	"./fog.svg": "7DyO",
	"./partly-sunny.svg": "YuOX",
	"./showers.svg": "ZrR9",
	"./sunny-with-showers.svg": "B72N",
	"./sunny.svg": "pmtt",
	"./windy.svg": "Btwd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "B4Oj";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.svg$
// module id = B4Oj
// module chunks = 1